<div class="box-header pageheader ">
    <div class="col-sm-12">
        <div class="col-sm-7 text-left" >
            <h3>{{title}}</h3>
        </div>
        <div class="col-sm-5 text-right">
            <button  type="button" class="btn btn-danger" style="margin-left: 10px" (click)="dialogRef.close(false)">Close</button>
        </div>
    </div>
</div>
<div class="box-body">
    <div class="col-sm-12" style="margin-bottom:20px">
        <div class="col-sm-5">Part Name: <strong>{{MachineName}}</strong></div>
        <div class="col-sm-5">Available Quantity: <strong>{{AvailableQuantity}}</strong></div>
    </div>

    <div class="table-responsive-custom">
        <table  style="width:97%" class="col-sm-12 BlackBorderTable no-footer">
            <thead>
                <tr>
                    <th width="8%">
                        Ref. #
                    </th>
                     
                    <th width="8%">
                        Date
                    </th>
                    <th width="5%">
                        Qty.
                    </th>
                    <th width="8%">
                        Tech
                    </th>
                    <th width="5%">
                        Division
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="PartsHistoryData && PartsHistoryData.length > 0">                
                <tr *ngFor="let item of PartsHistoryData;let index=index;">
                    <td align="left" valign="top">
                        <a (click)="setlinkMachine(item.formtype,'Dialysis Machines',item.dmRepairDetailsId, item.divisionName)"> {{item.repairid}} </a>
                    </td>
                    
                    <td>
                        <div align="center">
                            <div>
                                <p style="margin:0 !important;"> {{item.transDate | date:"dd/MM/yyyy"}} </p>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div>
                            <p style="margin:0 !important;">{{item.quantity}} </p>
                        </div>
                    </td>
                    <td>
                        <div>
                            <p style="margin:0 !important;"> {{item.givenName}} </p>
                        </div>
                    </td>
                    <td>
                        <div>
                            <p style="margin: 0 !important;">{{item.divisionName}}</p>
                        </div>
                    </td>
                </tr>
            </tbody>
            <tbody *ngIf="PartsHistoryData && PartsHistoryData.length == 0">
                <tr>
                    <td colspan="4" class="text-center text-muted"><em><strong>N/A</strong></em></td>
                </tr>
            </tbody>
        </table>
 
        <div class="col-sm-12">
            <div class="col-sm-9 text-right">
                <strong>Total Quantity:</strong>
                 <strong style="margin-left: 10px;">{{totalUsedQuantity}}</strong>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="box-header col-sm-12">
        <div class="col-sm-6 col-sm-offset-6 text-right">
            <button type="button" class="btn btn-danger" (click)="dialogRef.close(false)">Close</button>
        </div>
    </div>
</div>


  <ngb-alert style="z-index: 50000000000 !important" *ngIf="alertmessage" [type]="'error'" (close)="alertmessage.successMessage = null">
      {{ alertmessage }}</ngb-alert>
